<template>
    <div class="container my-4">
        <div v-if="head_info.page_type" class="card1 p-4 mb-4 border-0 rounded-4 bg-site-gradient1 w-100 text-start head_info">
            <h3 v-if="head_info.page_type == 'author'" class="fw-bold text-center text-sm-start">
                {{ head_info.translate[0].firstname ? head_info.translate[0].firstname + ' ' + head_info.translate[0].lastname : head_info.name }}
            </h3>
            <div class="card-body p-1 d-flex flex-column flex-sm-row align-items-center">
                <div class="me-3">
                    <img v-if="head_info.page_type != 'search' && head_info.image" :src="head_info.image"
                        class="rounded-circle my-2 my-sm-0" :style="head_info.page_type == 'author' ? 'height: 100px; width: 100px;' : 'height: 45px; width: 45px;'"
                    />
                    <i v-else-if="head_info.page_type == 'search'" class="fa fa-search fs-3"></i>
                </div>
                <div>
                    <div v-if="head_info.page_type == 'author'" v-html="head_info.translate[0].about" style="text-align: justify;"></div>

                    <h4 v-else-if="head_info.page_type == 'category'" class="fw-bold" v-html="head_info.name"></h4>

                    <div v-else-if="head_info.page_type == 'search'">
                        {{ TR.search_text }}: <b>{{ search_text }}</b>
                        <br>
                        {{ TR.msg_search_result }}: <b>{{ totalrecords }}</b>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="search_text != ''" class="card1 p-4 mb-4 border-0 rounded-4 bg-site-gradient1 w-100 text-start head_info">
            <div class="card-body p-1 d-flex flex-column flex-sm-row align-items-center">
                <div class="me-3">
                    <i class="fa fa-search fs-3"></i>
                </div>
                <div>
                    {{ TR.search_text }}: <b>{{ search_text }}</b>
                    <br>
                    {{ TR.msg_search_result }}: <b>{{ totalrecords }}</b>
                </div>
            </div>
        </div>

        <div class="row g-3">
            <div class="col-lg-8 posts">
                <!-- <Loading v-if="loading" /> -->

                <!-- <div v-if="category_id == 0" class="vector-header vector-header-wide fw-semibold mb-4" style="--h: 60px">
                    <div class="row m-0 w-100">
                        <div class="col ps-4">{{ TR.techno_news }}</div>
                    </div>
                </div> -->

                <BlogItem v-for="(post, index) in posts" :key="index" :data="post" :lang="TR" />
            </div>

            <div class="col-lg-4">
                <HomeSidebar :data="authors" />
            </div>
        </div>

        <!-- <div class="row1 g-31"> -->
            <Pagination
                v-if="posts.length"
                :row_count="totalrecords"
                :pages_count="pages_count"
                :lang="TR"
                :current_page="current_page"
                :perpage="perpage"
                :page_row_count="G.rowsPerPageOptions"
                @navigate="pagenav"
                class="pagenav mt-3"
            />
        <!-- </div> -->

    </div>

</template>


<script>
import { onBeforeMount, ref, watchEffect } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import { useStore } from "@/system_modules/store";

// import { useHead } from '@unhead/vue';

import BlogItem from '@/pages/component/BlogItem.vue';
import HomeSidebar from '@/pages/component/HomeSidebar.vue';
// import Loading from '@/components/elements/Loading.vue';
import Pagination from '@/components/elements/Pagination.vue';

import { G, ajax } from '@/_common';


export default {
    title: 'posts',
    name: 'AuthorPostsP',
    components: {
        BlogItem,
        HomeSidebar,
        // Loading,
        Pagination,
    },
    props:{
        data: {
            type: Object,
            default: () => {}
        },
    },
    setup() {
        const store = useStore();
        const route = useRoute();
        const router = useRouter();

        const TR = ref({});

        const authors = ref([]);
        const head_info = ref({});
        const posts = ref([]);
        // const posts_main = ref([]);
        const categories = ref([]);

        const pages_count = ref(0);
        const current_page = ref(null);
        const perpage = ref(G.rowsPerPage);
        const totalrecords = ref(0);
        const search_text = ref('');

		// const category_id = ref(0);
		const author_name = ref('');
		const author_id = ref(0);
		const route_obj = ref({});
        // const selectedFilters = ref({});
        // const selectedSortField = ref("create_date");
		// const selectedSortOrder = ref(-1);

        // const navigate = async (categoryId) => {
        //     // currentSection.value = categoryId;
        //     selectedCategory.value = categoryId;
        //     // toggleSidebar();
        //     sidebarCollapsed.value = false;
        //     // loadProducts();
        //     current_page.value = 1;
        //     await getProducts(categoryId);
        // };

        const page = route.params && route.params.page ? parseInt(route.params.page) : 1;
		// category_id.value = route.params && route.params.category_id ? parseInt(route.params.category_id) : 0;
		author_name.value = route.params && route.params.author_name ? route.params.author_name : 0;
		author_id.value = route.params && route.params.author_id ? parseInt(route.params.author_id) : 0;
		perpage.value = route.params && route.params.perpage ? parseInt(route.params.perpage) : G.rowsPerPage;
		search_text.value = route.query && route.params.search_text ? route.params.search_text : '';

        // const def_lang = route.params && route.params.lang ? route.params.lang : "az";

        // selectedSortField.value = route.params.sortfield || "create_date";
        // selectedSortOrder.value = parseInt(route.params.sortorder || -1);

        // let title = '';
        // let description = '';
        // let image = `https://${G.main_host}/favicon.png`;

        // const rpath = router.resolve({
        //     name: 'author_detail',
        //     // page: page,
        //     // perpage: perpage.value,
        //     // category_id: parseInt(category_id.value) || 0,
        //     author_name: author_name.value || 0,
        //     author_id: parseInt(author_id.value) || 0,
        //     // search_text: search_text.value || '',
        // }).path;

        current_page.value = page;

        const pagenav = async (p, pp) => {
            perpage.value = pp;
            // if( search_text.value != '' )
            //     await getPosts(p);
            // else
            //     await getPosts(p);
            await getPosts(p);

            router.push({name: 'author_post_paging', params: route_obj.value});
        }

        const searchCallback = (event) => {
            if( event.which == 13 || event.which == 1 ){
                current_page.value = 1;
                getPosts(1);
            }
        };

        const getPosts = async (first) => {
            if( first === undefined ) first = 1;
            route_obj.value = {
				// params: {
					page: first,
					perpage: perpage.value,
					// category_id: parseInt(category_id.value) || 0,
					author_name: author_name.value || 0,
					author_id: parseInt(author_id.value) || 0,
					// sortfield: selectedSortField.value,
					// sortorder: selectedSortOrder.value,
					// filters: Object.keys(selectedFilters.value).filter((k) => selectedFilters.value[k] == true).join(',') || '0',
					search_text: search_text.value || '',
				// },
				// query: {
				// 	search_text: search_text.value || '',
				// }
			};

            // router.push({name: 'post_paging', params: route_obj.value});

            // await ajax({
            //     loading: true,
            //     url: store.getPostPaging(route_obj.value), // + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
            //     success: (e) => {
            //         posts.value = e.data.data;
            //         totalrecords.value = e.data.total_records;
            //         pages_count.value = Math.ceil(e.data.total_records / perpage.value);
            //     }
            // });
        };

        watchEffect(() => {
            TR.value = store.getTranslation();

            // if( head_info.value.page_type == 'category' ){
            //     title = head_info.value.name;
            //     description = head_info.value.name;
            //     image = head_info.value.image;
            // }
            // else
            // if( head_info.value.page_type == 'author' ){
            //     title = head_info.value.translate[0].firstname + ' ' + head_info.value.translate[0].lastname;
            //     description = head_info.value.translate[0].about;
            //     image = head_info.value.image;
            // }
        });

        onBeforeMount(async() => {
			await getPosts(page);

            await ajax({
                loading: true,
                url: store.getAuthorsPostPaging(route_obj.value), // + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
                success: (e) => {
                    posts.value = e.data.data;
                    totalrecords.value = e.data.total_records;
                    pages_count.value = Math.ceil(e.data.total_records / perpage.value);
                }
            });

			if( author_id.value ){
                await ajax({
                    url: store.getAuthorUpdate(author_id.value),
                    success: (e) => {
                        head_info.value = e.data;
                        head_info.value.page_type = 'author';
                    }
                });
            }
			// else if( category_id.value ){
            //     await ajax({
            //         url: store.getCategoryById(category_id.value),
            //         success: (e) => {
            //             head_info.value = e.data;
            //             head_info.value.page_type = 'category';
            //         }
            //     });
            // }
            else if ( search_text.value ){
                head_info.value.page_type = 'search';
            }

            // await ajax({
            //     // loading: true,
            //     url: store.getPostsMain(), // + `?rows=${perpage.value}&first=${(first-1)*perpage.value}&search_text=${encodeURIComponent(search_text.value)}`,
            //     success: (e) => {
            //         posts_main.value = e.data.data;
            //         // totalrecords.value = e.data.total_records;
            //         // pages_count.value = Math.ceil(e.data.total_records / perpage.value);
            //     }
            // });

			await ajax({
				url: store.getAuthor(),
				success: (e) => {
					authors.value = e.data.data;
				}
			});
		});

        // useHead({
        //     title: computed(() => title),
        //     meta: [
        //         // Primary Meta Tags
        //         { name: 'title', content: computed(() => title)},
        //         { name: 'description', content: computed(() => description)},
        //         { name: 'robots', content: 'index, follow'},
        //         { name: 'viewport', content: 'width=device-width, initial-scale=1'},

        //         // Open Graph / Facebook
        //         { property: 'og:title', content: computed(() => title)},
        //         { property: 'og:description', content: computed(() => description)},
        //         { property: 'og:url', content: computed(() => `https://${G.main_host}${rpath}`)},
        //         { property: 'og:image', itemprop: 'image', content: computed(() => image)},
        //         { property: 'og:image:width', content: '600' },
        //         { property: 'og:image:height', content: '315' },
        //         { property: 'og:image:alt', content: computed(() => title) },
        //         { property: 'og:image:type', content: 'image/jpeg' },
        //         { property: 'og:site_name', content: computed(() => `https://${G.main_host}${rpath}`)},
        //         { property: 'og:locale', content: computed(() => `${def_lang}-${def_lang.toLocaleUpperCase()}`) },
        //         { property: 'og:type', content: 'article'},

        //         // Open Graph - Article Specific
        //         // { property: 'article:published_time', content: computed(() => post.value?.create_date)},
        //         // { property: 'article:modified_time', content: computed(() => G.dateToStr(post.value?.update_date, 'datetime', 'datetime_as_pg'))},
        //         // { property: 'article:author', content: computed(() => `${post.value.author?.translate[0].firstname} ${post.value.author?.translate[0].lastname}`) },
        //         { property: 'article:section', content: computed(() => title) },

        //         // Twitter
        //         { name: 'twitter:card', content: 'summary_large_image'},
        //         { name: 'twitter:title', content: computed(() => title)},
        //         { name: 'twitter:description', content: computed(() => description)},
        //         { name: 'twitter:url', content: computed(() => `https://${G.main_host}${rpath}`)},
        //         { name: 'twitter:image', content: computed(() => image)},
        //         { name: 'twitter:site', content: computed(() => `https://${G.main_host}${rpath}`)},
        //         { name: 'twitter:creator', content: computed(() => title) },
        //     ],
        // });

        return {
            G,
            TR,

            // loading,
            pages_count,
            current_page,
            perpage,
            totalrecords,
            // navigate,
            pagenav,
            searchCallback,
            search_text,

            categories,
            authors,
            posts,
            // posts_main,
            head_info,
            // category_id,
		};
    },
}
</script>


<style lang="scss">
// :root {
//     --primary-color: #D32F2F;
//     --secondary-color: #FBC02D;
//     --background-color: #FAFAFA;
//     --header-background: #FFFFFF;
//     --footer-background: #212121;
//     --text-color: #212121;
//     --muted-text-color: #757575;
//     --card-border-color: #EEEEEE;
// }
// .posts {
    .posts > .card {
        border: 1px solid var(--card-border-color);
        // border-radius: 1rem;
        transition: box-shadow .3s;
    }
    .posts > .card:hover {
        box-shadow: 0 0 21px rgba(33, 33, 33, .2);
        cursor: pointer;
        scale: 1.01;
    }
    .posts > .card a{
        color: rgb(var(--site-primary-color-rgb));
    }
// }

.head_info{
    box-shadow: var(--shadow);
}

</style>